var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyIconBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "w07nh20kza",
    width: "104.2%",
    height: "104.7%",
    x: "-2.1%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "3hzctjlkrb",
    width: "146.2%",
    height: "166.7%",
    x: "-23.1%",
    y: "-33.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#w07nh20kza)",
    transform: "translate(-482 -520) translate(456 180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#3hzctjlkrb)",
    transform: "translate(24 228) translate(8 114)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 36,
    fill: "#5f00a0",
    rx: 2.667
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M36.859 22L43.141 18 36.859 14z",
    transform: "rotate(90 40 18)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.033 20.403h7.85v-1.054h-7.85v1.054zm-1.671-2.43L5 20.289l-1.108-1.085-.76.745L5 21.778l3.122-3.06-.76-.744zm1.67-2.927h7.851v-1.054h-7.85v1.054zm-1.67-2.43L5 14.931l-1.108-1.085-.76.745L5 16.421l3.122-3.06-.76-.745zm1.67-2.927h7.851V8.635h-7.85v1.054zm-1.67-2.43L5 9.574 3.892 8.49l-.76.745L5 11.064l3.122-3.06-.76-.745zm-5.79-5.185C.702 2.074 0 2.761 0 3.614v21.81c0 .853.701 1.54 1.572 1.54h16.871c.871 0 1.572-.687 1.572-1.54V11.93l-1.644.857V23.13c0 .54-.464.974-1.041.974H2.685c-.577 0-1.04-.434-1.04-.974V6.581c0-.539.463-.973 1.04-.973H17.33c.577 0 1.041.434 1.041.974v6.206l1.644-.857V3.614c0-.853-.7-1.54-1.572-1.54h-2.505v.56c0 1.079-.9 1.96-2.002 1.96H6.08c-1.102 0-2.002-.881-2.002-1.96v-.56H1.572zM6.079 0c-.871 0-1.572.687-1.572 1.54v1.093c0 .853.701 1.54 1.572 1.54h7.857c.871 0 1.572-.687 1.572-1.54V1.54c0-.853-.701-1.54-1.572-1.54H6.08z",
    transform: "translate(7.875 4.5)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIconBlue);
export default __webpack_public_path__ + "static/media/verify_icon_blue.d3af7727afd79fd282fd2258e3effe25.svg";
export { ForwardRef as ReactComponent };